import React from "react";
import "./styles.css";
import SettingsPage from "./settings";

export default function App() {
  return (<div className="App"><SettingsPage /></div>);
}
